export default __webpack_public_path__ + "static/media/arrow-left-dark.a2fef561.png";